export default {
  'app.pwa.offline': 'Você está offline agora',
  'app.pwa.serviceworker.updated': 'Novo conteúdo está disponível',
  'app.pwa.serviceworker.updated.hint':
    'Clique no botão "Atualizar" para recarregar a página atual',
  'app.pwa.serviceworker.updated.ok': 'Atualizar',
  'app.updateCheck.title': 'Verificação de Atualizações',
  'app.updateCheck.backend': 'Backend',
  'app.updateCheck.frontend': 'Frontend',
  'app.updateCheck.upToDate': 'Atualizado',
  'app.updateCheck.newVersionAvailable':
    '{count} nova(s) atualização(ões) disponível(is)',
  'app.updateCheck.allUpToDate': 'Todos os componentes estão atualizados',
  'app.updateCheck.viewRelease': 'Ver Release',
  'app.updateCheck.recheck': 'Verificar Novamente',
  'app.updateCheck.close': 'Fechar',
  'app.updateCheck.failed':
    'Falha na verificação de atualizações, tente novamente mais tarde',
};
